<template>
  <b-badge
    class="network-status-badge"
    pill
    :variant="variant"
    v-text="label"
  />
</template>

<script>
import { moduleStatus } from '@/domain/enums/module';

export default {
  props: {
    value: String,
  },
  computed: {
    variant() {
      switch (this.value) {
        case moduleStatus.ACTIVE:
          return 'active';
        case moduleStatus.INACTIVE:
          return 'inactive';
        case moduleStatus.ESTABLISHING_COMMUNICATION:
          return 'establishing-communication';
        case moduleStatus.DISABLED:
          return 'disabled';
        case moduleStatus.UNDER_MAINTENANCE:
          return 'under-maintenance';
        case moduleStatus.SIMULATION:
          return 'simulation';
        case moduleStatus.PARTIAL_COMMUNICATION:
          return 'partial-communication';
        default:
          return 'indeterminate';
      }
    },
    label() {
      return this.$t(`enums.module-status.${this.value}`);
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"
@import "src/styles/vendor/customizations/custom-bootstrap-vars.sass"
@import ~bootstrap/scss/mixins/_badge
@import ~bootstrap/scss/mixins/_hover
@import "src/styles/components/badge-default-colors.sass"

.network-status-badge
  padding: 5px
  &.badge-active
    @include badge-variant($status-active)
    color: #fff
  &.badge-inactive
    @include badge-variant($status-inactive)
    color: #fff
  &.badge-disabled
    @include badge-variant($status-disabled)
    color: #fff
  &.badge-establishing-communication
    @include badge-variant($status-establishing-communication)
    color: #fff
  &.badge-under-maintenance
    @include badge-variant($status-under-maintenance)
    color: #fff
  &.badge-simulation
    @include badge-variant($status-simulation)
    color: #fff
  &.badge-partial-communication
    @include badge-variant($status-partial-communication)
    color: #fff
  &.badge-indeterminate
    @include badge-variant($status-indeterminate)
    color: #fff
</style>
